import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { forwardRef } from "react";
import { bgStyles, borderStyles, paddingStyles, svgStyles, textStyles } from "ui";

export const Button = forwardRef<HTMLButtonElement, ComponentProps["SideMenu"]["Button"]>((props, ref) => {
  const { className, children, icon, onClick, onDragEnd, onDragStart, draggable, label } = props;

  return (
    <button
      className={classNames(
        borderStyles.none,
        textStyles.businessTextColor,
        svgStyles.textColor,
        bgStyles.none,
        paddingStyles.p0,
        className,
      )}
      ref={ref}
      aria-label={label}
      onClick={onClick}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      draggable={draggable}
      type="button"
    >
      {icon}
      {children}
    </button>
  );
});
